import React, { FC, useMemo, useState } from "react";
import {
  SortHighestIcon,
  SortLongIcon,
  SortLowestIcon,
  SortShortIcon,
  SortSupplierAZIconIcon,
  SortSupplierZAIcon
} from "assets/svgs";
import RatesDropdown from "containers/retail/sections/energy-rates-3/RatesDropdown";
import useTheme from "evcharging/hooks/useTheme";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import clsx from "clsx";
import useI18n from "evcharging/hooks/useI18n";

interface RatesSortingProps {
  onSort: (sort: string) => void;
  sort: string;
}

const options = [
  {
    label: 'rates.sort.price-lowest',
    value: 'price,asc',
    icon: <SortLowestIcon />,
  },
  {
    label: 'rates.sort.price-highest',
    value: 'price,desc',
    icon: <SortHighestIcon />,
  },
  {
    label: 'rates.sort.term-shortest',
    value: 'term,asc',
    icon: <SortShortIcon />,
  },
  {
    label: 'rates.sort.term-longest',
    value: 'term,desc',
    icon: <SortLongIcon />,
  },
  {
    label: 'rates.sort.supplier-az',
    value: 'supplier,asc',
    icon: <SortSupplierAZIconIcon />,
  },
  {
    label: 'rates.sort.supplier-za',
    value: 'supplier,desc',
    icon: <SortSupplierZAIcon />,
  },
];

const RatesSorting: FC<RatesSortingProps> = (props) => {
  const { onSort, sort } = props;

  const { t } = useI18n();

  const theme = useTheme();
  const classes = createStyles(theme);

  const placeholder = useMemo(() => {
    const option = options.find((item) => item.value === sort);
    return (
      <div className={classes.placeholder}>
        {option.icon}
        <p>{t(option.label)}</p>
      </div>
    );
  }, [sort]);
  const [open, setOpen] = useState<boolean>(false);
  const onToggle = () => setOpen(!open);

  const handleMenuItemClick = (itemValue: string) => () => {
    if (itemValue !== sort) {
      onSort(itemValue);
      onToggle();
    }
  };

  return (
    <RatesDropdown placeholder={placeholder} open={open} onToggle={onToggle} width={173}>
      {options.map((item) => (
        <div
          key={item.value}
          className={clsx(classes.menuItem, item.value === sort && classes.active)}
          onClick={handleMenuItemClick(item.value)}
        >
          {item.icon}
          <p>{t(item.label)}</p>
        </div>
      ))}
    </RatesDropdown>
  );
};

const createStyles = (theme: Theme) => ({
  menuItem: css({
    display: 'flex',
    fontWeight: 600,
    fontSize: 14,
    color: '#000',
    padding: '6px 12px',
    p: {
      marginLeft: 10,
    },
    cursor: 'pointer',
  }),
  active: css({
    background: '#ededed',
  }),
  placeholder: css({
    display: 'flex',
    p: {
      marginLeft: 10,
    }
  }),
});

export default RatesSorting;
